import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1000px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
              话题热度
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热门PK话题标签
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              点击话题标签，快速跳转到你最关心的娱乐PK对决
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href="#ranking"
                className="group relative inline-flex items-center gap-3 px-5 py-3.5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline"
              >
                <span className={`w-3 h-3 rounded-full flex-shrink-0 ${topic.color}`}></span>
                <span className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">
                  {topic.heat}票
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}